import { JsonObject } from 'ta-json';
import { HelpItem } from '@ess/jg-rule-executor/dist/src/domain/HelpItem';
import { PortalAsset } from '@src/app/model/portal-asset';
import { GetAllRetailers_allRetailers_edges_node_retailerOptions_helpItems } from '@src/app/generated/GetAllRetailers';
import { HelpItemInput } from '@src/app/generated/globalTypes';

@JsonObject()
export class PortalHelpItem extends HelpItem {
  constructor(
    order: number,
    title: string,
    videoAsset?: PortalAsset,
    thumbnailAsset?: PortalAsset,
  ) {
    super(order, title, videoAsset, thumbnailAsset);
  }

  static fromGql(gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_helpItems): PortalHelpItem {
    return new PortalHelpItem(
      gql.order,
      gql.title,
      gql.videoAsset ? PortalAsset.fromGql(gql.videoAsset) : undefined,
      gql.thumbnailAsset ? PortalAsset.fromGql(gql.thumbnailAsset) : undefined
    );
  }

  public toGqlInput(): HelpItemInput {
    return {
      order: this.order,
      title: this.title,
      videoAsset: (this.videoAsset as PortalAsset)
        ? (this.videoAsset as PortalAsset).toGqlInput()
        : undefined,
      thumbnailAsset: (this.thumbnailAsset as PortalAsset)
        ? (this.thumbnailAsset as PortalAsset).toGqlInput()
        : undefined,
    };
  }
}
